const playerHasChangeReducer = (state = false, action) => {
  switch (action.type) {
    case 'ADMIN_PLAYER_HAS_CHANGE':
      return action.data
    default:
      return state
  }
}

export default playerHasChangeReducer
